import React, { useState } from "react";
import DataTable from "../DataTable";
import ServiceComboForm from "./ServiceComboForm";
import { Link } from "react-router-dom";
import { gql, useMutation } from "@apollo/client";
import CustomSwitch from "../CommonComponents/CustomSwitch";
import { useAuthz } from "../../auth/useAuthz";

const DELETE_SERVICE_COMBO = gql`
  mutation deleteServiceCombo($data: ID!) {
    deleteServiceCombo(data: $data) {
      status
      message
    }
  }
`;

const UPDATE_SERVICE_COMBO = gql`
  mutation updateServiceCombo($data: UpdateServiceComboInput!) {
    updateServiceCombo(data: $data) {
      status
      message
    }
  }
`;

const ServiceComboTable = ({ combos }) => {
  const { can } = useAuthz();
  const [deleteServiceCombo] = useMutation(DELETE_SERVICE_COMBO);
  const [toggleActive] = useMutation(UPDATE_SERVICE_COMBO);

  const [editForm, setEditForm] = useState(false);
  const [editData, setEditData] = useState(null);
  const [addForm, setAddForm] = useState(false);

  const handleDelete = (id) => {
    if (!window.confirm("Delete this service combo?")) return;
    deleteServiceCombo({ variables: { data: id } }).then((res) => {
      if (res.data.deleteServiceCombo.status === "SUCCESS") {
        window.location.reload();
      }
    });
  };

  const showForm = editForm || addForm;

  return (
    <div className="flex flex-col space-y-6">
      {!showForm && (
        <div className="flex justify-center xl:justify-between text-[#FBB033] items-center font-be-jost-pro text-xl font-bold space-x-3 pt-8 pl-5">
          <div className="flex text-[#FBB033] items-center font-be-jost-pro text-xl font-bold space-x-3 pt-8 pl-5">
            <Link
              to="/admin/services"
              className="text-[#FBB034] hover:bg-white hover:text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left"
            >
              <span>Services</span>
            </Link>
            <p className="bg-white text-[#00395E] rounded-sm cursor-pointer text-base px-2 py-1 font-semibold font-be-jost-pro text-center md:text-left">
              Service Combos
            </p>
          </div>
          {can("services.create") && (
            <button
              className="border border-[#ab997b] bg-black text-[#FBB033] font-be-jost-pro font-medium text-sm rounded-md px-10 py-2"
              onClick={() => {
                setEditData(null);
                setAddForm(true);
              }}
            >
              Add Combo
            </button>
          )}
        </div>
      )}

      {editForm ? (
        <ServiceComboForm comboFormData={editData} onClose={() => setEditForm(false)} />
      ) : addForm ? (
        <ServiceComboForm comboFormData={null} onClose={() => setAddForm(false)} />
      ) : (
        <div>
          <DataTable tableName="ServiceCombos">
            <thead>
              <tr>
                <th data-priority="1" className="text-white">
                  Name
                </th>
                <th data-priority="2" className="text-white">
                  Services
                </th>
                <th data-priority="3" className="text-white">
                  Shared Inventory
                </th>
                <th data-priority="4" className="text-white">
                  Priority
                </th>
                <th data-priority="5" className="text-white">
                  Active
                </th>
                <th data-priority="6" className="text-white">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {combos.map((combo) => (
                <tr key={combo.id} className="border-b-2 border-b-[#E0E0E0]">
                  <td className="text-white w-[15%] px-1 border-b-[1px] border-b-[#E0E0E0]">
                    {combo.name}
                  </td>
                  <td className="w-[25%] border-b-[1px] border-b-[#E0E0E0]">
                    <div className="flex flex-wrap gap-1">
                      {(combo.services || []).map((s) => (
                        <div
                          key={s.id}
                          className="bg-[#FBB033] rounded-2xl px-3 py-1 flex justify-center"
                        >
                          <p className="uppercase text-xs font-medium text-black">{s.name}</p>
                        </div>
                      ))}
                    </div>
                  </td>
                  <td className="text-white w-[25%] border-b-[1px] border-b-[#E0E0E0]">
                    {(combo.inventoryList || [])
                      .map(
                        (item) =>
                          `${item.comboInventoryCategory?.name || "?"} x${item.price}`,
                      )
                      .join(", ")}
                  </td>
                  <td className="text-white w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                    {combo.priority}
                  </td>
                  <td className="w-[7%] text-center border-b-[1px] border-b-[#E0E0E0]">
                    <CustomSwitch
                      checked={combo.isActive}
                      onChange={() => {
                        toggleActive({
                          variables: { data: { id: combo.id, isActive: !combo.isActive } },
                        }).then((res) => {
                          if (res.data.updateServiceCombo.status === "SUCCESS") {
                            window.location.reload();
                          }
                        });
                      }}
                      id={combo.id}
                    />
                  </td>
                  <td className="w-[10%] text-center px-2 border-b-[1px] border-b-[#E0E0E0]">
                    <div className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 items-center justify-center h-full lg:space-x-2">
                      {can("services.edit") && (
                        <button
                          className="rounded-md bg-white py-2 px-3 text-black text-sm font-medium"
                          onClick={() => {
                            setEditData(combo);
                            setEditForm(true);
                          }}
                        >
                          Edit
                        </button>
                      )}
                      {can("services.create") && (
                        <button
                          className="rounded-md bg-white py-2 px-3 text-black text-sm font-medium"
                          onClick={() => handleDelete(combo.id)}
                        >
                          Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </div>
      )}
    </div>
  );
};

export default ServiceComboTable;
